import fetch from 'isomorphic-fetch'
import {authHeader, handleResponse} from "./helpers";
import {API_URL} from "../../constants/Config";

export const accountService = {
  getInfo,
  getApiKey,
  reset,
  createEventsKey,
  getUsers,
  inviteUser,
  removeUser,
  updateRole,
  getPricingDetails,
  sendPricingDetails,
  getTrialUsage,
  getBillingPortalUrl
};


async function getInfo(auth_token, product) {
  const url = `${API_URL}/account?product=${product}`;
  const options = {
    method: 'GET',
    headers: authHeader(auth_token)
  };
  return fetch(url, options)
    .then((response) => handleResponse(response))
}

async function getTrialUsage(auth_token, product) {
  const url = `${API_URL}/account/trial_usage?product=${product}`;
  const options = {
    method: 'GET',
    headers: authHeader(auth_token)
  };
  return fetch(url, options)
    .then((response) => handleResponse(response))
}

async function getApiKey(auth_token) {
  const url = `${API_URL}/account/api_key`;
  const options = {
    method: 'GET',
    headers: authHeader(auth_token)
  };
  return fetch(url, options)
    .then((response) => handleResponse(response))
    .then((response) => response.api_key);
}

async function reset(auth_token, product) {
  let url = `${API_URL}/account/reset`
  if (product) {
    url += `?product=${product}`
  }
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({}),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function createEventsKey(auth_token) {
  const url = `${API_URL}/account/events_key`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({}),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function getUsers(auth_token) {
  const url = `${API_URL}/account/users`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function inviteUser(auth_token, email,role) {
  const url = `${API_URL}/account/users`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      email: email,
      role: role
    }),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function removeUser(auth_token, userId) {
  const url = `${API_URL}/account/users/${userId}`
  const options = {
    method: 'DELETE',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function updateRole(auth_token, userId,role) {
  const url = `${API_URL}/account/users/${userId}`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      role: role
    }),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function getPricingDetails(auth_token) {
  const url = `${API_URL}/account/pricing`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}
async function sendPricingDetails(auth_token,pricingPlan) {
  const url = `${API_URL}/account/checkout`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(pricingPlan),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}

async function getBillingPortalUrl(auth_token) {
  const url = `${API_URL}/account/billing_portal`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}
